import { createContext, useEffect, useState } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // important
  const [loading, setLoading] = useState(true);

  const checkAuth = () => {
    const token = localStorage.getItem("access");
    setIsAuthenticated(!!token);
    setLoading(false);
  };

  useEffect(() => {
    checkAuth();

    const handleAuthChange = () => checkAuth();
    const handleLogout = () => {
  localStorage.clear();
  setIsAuthenticated(false);
};

    window.addEventListener("authChanged", handleAuthChange);
    window.addEventListener("authLogout", handleLogout);

    return () => {
      window.removeEventListener("authChanged", handleAuthChange);
      window.removeEventListener("authLogout", handleLogout);
    };
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, loading }}>
      {children}
    </AuthContext.Provider>
  );
};